// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"4d651e8b","422":"af7d5078"}[chunkId] + ".chunk.js";
};